import { render, staticRenderFns } from "./invoice-payment-confirmation-page.vue?vue&type=template&id=1d824724&scoped=true&"
import script from "./invoice-payment-confirmation-page.vue?vue&type=script&lang=ts&"
export * from "./invoice-payment-confirmation-page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d824724",
  null
  
)

export default component.exports